import { render, staticRenderFns } from "./UiBadge.vue?vue&type=template&id=3260c4f3&"
import script from "./UiBadge.vue?vue&type=script&lang=js&"
export * from "./UiBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports